import { render, staticRenderFns } from "./CompanionForm.vue?vue&type=template&id=623ec3e8&scoped=true&"
import script from "./CompanionForm.vue?vue&type=script&lang=js&"
export * from "./CompanionForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanionForm.vue?vue&type=style&index=0&id=623ec3e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623ec3e8",
  null
  
)

export default component.exports